import { useEffect, useState } from 'react'

import { useQuery } from '@tanstack/react-query'

import { fetchAttributes } from 'api/AccountAPI'

export enum AccountPropertyType {
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  NUMBER = 'NUMBER',
  LAT = 'LAT',
  LON = 'LON',
  TEAMMEMBER = 'TEAMMEMBER',
  URL = 'URL',
  ENUM = 'ENUM',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  STRING = 'STRING',
  LATLON = 'LATLON',
  ENUMARRAY = 'ENUMARRAY'
}

export interface AccountProperty {
  orgId: number
  type: AccountPropertyType
  label: string
  userId: number
  createDateTime: number
  updateDateTime: number
  name: string
  deleted: boolean
  options: string[]
}

export default function useDriftAccountProperties() {
  const [driftProperties, setDriftProperties] = useState<AccountProperty[]>([])

  const { data } = useQuery<AccountProperty[]>({
    queryKey: ['fetchAttributes'],
    queryFn: () => fetchAttributes()
  })

  useEffect(() => {
    if (data) {
      const notDeleted = data.filter(property => !property.deleted)
      const propertiesWithPickLists = notDeleted.filter(
        property => property.type === 'ENUM' || property.type === 'ENUMARRAY'
      )
      const nonEmptyPickLists = propertiesWithPickLists.filter(
        property => property.options.length > 0
      )
      setDriftProperties(nonEmptyPickLists)
    }
  }, [data])

  return { driftProperties }
}
